var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveyExpiration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 294,
    height: 248.067,
    viewBox: "0 0 294 248.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4775",
    "data-name": "Group 4775",
    transform: "translate(-573 -227.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3432",
    "data-name": "Path 3432",
    d: "M15716.035-10037.7h134.382l-.333-155.026-20.851-.747-5.3,6.228h-81.2l-6.155-6.228-16.886.747-3.652,6.1Z",
    transform: "translate(-15063 10484.23)",
    fill: "#f3f8fc",
    stroke: "#ee5f5f",
    strokeWidth: 1,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2743",
    "data-name": "Ellipse 2743",
    cx: 147,
    cy: 19.5,
    rx: 147,
    ry: 19.5,
    transform: "translate(573 436.5)",
    fill: "#f3f8fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2290855_check_document_done_list_paper_icon",
    "data-name": "2290855_check_document_done_list_paper_icon",
    transform: "translate(573.578 239)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_998",
    "data-name": "Line 998",
    x2: 13.631,
    transform: "translate(189.169 48.402)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3419",
    "data-name": "Path 3419",
    d: "M397.066,82.7a8.843,8.843,0,0,1,8.8,8.9",
    transform: "translate(-194.265 -34.294)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_999",
    "data-name": "Line 999",
    y2: 141.32,
    transform: "translate(211.599 57.301)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3420",
    "data-name": "Path 3420",
    d: "M405.864,453.047a8.852,8.852,0,0,1-8.8,8.9",
    transform: "translate(-194.266 -254.425)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1000",
    "data-name": "Line 1000",
    x1: 112.76,
    transform: "translate(90.041 207.526)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3421",
    "data-name": "Path 3421",
    d: "M90.041,461.951a8.855,8.855,0,0,1-8.8-8.9",
    transform: "translate(0 -254.425)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1001",
    "data-name": "Line 1001",
    y1: 141.32,
    transform: "translate(81.244 57.301)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3422",
    "data-name": "Path 3422",
    d: "M81.244,91.6a8.846,8.846,0,0,1,8.8-8.9",
    transform: "translate(0 -34.294)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1002",
    "data-name": "Line 1002",
    x2: 11.752,
    transform: "translate(90.041 48.402)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    "data-name": "Path 3423",
    d: "M309.652,47.787H286.991V45.851",
    transform: "translate(-127.074 -12.394)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    "data-name": "Path 3424",
    d: "M274.764,33.457A8.4,8.4,0,0,0,266.42,25",
    transform: "translate(-113.89 0)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1003",
    "data-name": "Line 1003",
    x1: 13.304,
    transform: "translate(139.777 25)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    "data-name": "Path 3425",
    d: "M221.361,25a8.414,8.414,0,0,0-8.367,8.457",
    transform: "translate(-81.032)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    "data-name": "Path 3426",
    d: "M179.82,45.851v1.936H157.181",
    transform: "translate(-46.9 -12.394)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3427",
    "data-name": "Path 3427",
    d: "M144.937,50.625a8.414,8.414,0,0,0-8.355,8.468",
    transform: "translate(-34.035 -15.231)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3429",
    "data-name": "Path 3429",
    d: "M351.215,59.093a8.4,8.4,0,0,0-8.356-8.468",
    transform: "translate(-160.903 -15.231)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1006",
    "data-name": "Line 1006",
    x2: 56.61,
    transform: "translate(134.009 105.499)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1007",
    "data-name": "Line 1007",
    x2: 56.61,
    transform: "translate(134.009 174.088)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1008",
    "data-name": "Line 1008",
    x2: 56.61,
    transform: "translate(134.009 140.291)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3428",
    "data-name": "Path 3428",
    d: "M136.582,71.5V89.494h82.5V71.5",
    transform: "translate(-31.446 -29.641)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4302",
    "data-name": "Rectangle 4302",
    transform: "translate(100.422 97.217)",
    fill: "rgba(238,243,255,0.6)",
    stroke: "#bbcdff",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 13.5,
    height: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4303",
    "data-name": "Rectangle 4303",
    transform: "translate(100.422 132.217)",
    fill: "rgba(238,243,255,0.6)",
    stroke: "#bbcdff",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 13.5,
    height: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4304",
    "data-name": "Rectangle 4304",
    transform: "translate(100.422 166.217)",
    fill: "rgba(238,243,255,0.6)",
    stroke: "#bbcdff",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 13.5,
    height: 13.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1854",
    transform: "translate(759.127 -65.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circle1840",
    d: "M46.321,292.65a44.322,44.322,0,1,0,44.321,44.321A44.389,44.389,0,0,0,46.321,292.65Zm0,8.864a35.457,35.457,0,1,1-35.457,35.457A35.39,35.39,0,0,1,46.321,301.514Z",
    transform: "translate(0 0)",
    fill: "#bbcdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1842",
    d: "M42.157,299.948a4.432,4.432,0,0,0-6.268,0L25.728,310.111,15.567,299.948A4.432,4.432,0,1,0,9.3,306.216L19.46,316.377,9.3,326.538a4.432,4.432,0,1,0,6.268,6.268l10.161-10.161,10.161,10.161a4.432,4.432,0,1,0,6.268-6.268L32,316.377l10.161-10.161a4.432,4.432,0,0,0,0-6.268Z",
    transform: "translate(20.594 20.593)",
    fill: "#bbcdff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyExpiration);
export default __webpack_public_path__ + "static/media/surveyExpiration.d8c0576c8205c8590100a1c236d53652.svg";
export { ForwardRef as ReactComponent };